type ReferrerParams = {
  referrer: string;
  name: string;
};

const parseReferrerQueryParams = (searchString: string): ReferrerParams => {
  const searchParams = new URLSearchParams(searchString);

  return {
    referrer: searchParams.get("referrer") || "",
    name: searchParams.get("name") || "",
  };
};

export default parseReferrerQueryParams;
